export function autoLogout() {
  localStorage.removeItem("_biskon_session");
  localStorage.removeItem("permissions");
  localStorage.removeItem("recoveryEmail");
  localStorage.removeItem("countdown");
  window.location.href = "/login";
}
